import config from 'config';
import urlModule from 'modules/url';

export default class ComponentUtils {
    public formatPrice(price: number, locale: string = null, currency: string = null, minimumFractionDigits: number = 2): string {
        if (locale && currency) {
            return new Intl.NumberFormat(locale, {
                minimumFractionDigits,
                style: 'currency',
                currency,
            }).format(price);
        } else {
            const formatter = new Intl.NumberFormat(config.language, { style: 'currency', currency: 'EUR' });
            const formattedPrice = formatter.format(price);

            return formattedPrice.replace('€', config.currency);
        }
    }

    public escapeUserProvidedText(text: string): string {
        return text.replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }

    public generateHighlightedHtml(text: string, query: string): string {
        const term = query.trim().replace(
            // Character range that covers pretty much any common writing system. This regex excludes special
            // characters such as "!", "," or ".".
            /[^\w\u007F-\uFFFF']+/gi,
            '|'
        );

        const replacer = (match: string) => {
            const wrapper = document.createElement('span');
            wrapper.textContent = match;
            wrapper.className = 'fl-as-highlighted-text';

            return wrapper.outerHTML;
        };

        return this.escapeUserProvidedText(text).replace(new RegExp(term, 'gi'), replacer);
    }

    public addQueryParams(url: string, params: Record<string, any>): string {
        return urlModule.addQueryParams(url, params);
    }
}
